var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateLhc-8"},[_c('group',{attrs:{"client":_vm.client,"list":_vm.Table[0],"length":3,"interval":_vm.interval,"radio":true,"transmit":false}}),_c('BoardFast',{attrs:{"client":_vm.client,"group":[0],"step":true,"transmit":"six-tail","radio":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }